export enum AccountOperationType {
  PRE_CREATE_VERIFY = 'ACCOUNT_OPERATION_PRE_CREATE_VERIFY',
  POST_CREATE_VERIFY = 'ACCOUNT_OPERATION_POST_CREATE_VERIFY',
  RECOVER_USER_ID = 'ACCOUNT_OPERATION_RECOVER_USER_ID',
  PRE_CHANGE_PASSWORD_VERIFY = 'ACCOUNT_OPERATION_PRE_CHANGE_PASSWORD_VERIFY',
  POST_CHANGE_PASSWORD_VERIFY = 'ACCOUNT_OPERATION_POST_CHANGE_PASSWORD_VERIFY',
  CHANGE_PASSWORD_AUTHENTICATED = 'ACCOUNT_OPERATION_CHANGE_PASSWORD_AUTHENTICATED',
  CHANGE_EMAIL_AUTHENTICATED = 'ACCOUNT_OPERATION_CHANGE_EMAIL_AUTHENTICATED',
  DELETE_ACCOUNT = 'ACCOUNT_OPERATION_DELETE_ACCOUNT',
}

export enum InterfaceResponseEnum {
  NO_REASON = 0,
  BAD_REQUEST = 1,
  INVALID_PARAMS = 2,
  UNAUTHORIZED = 3,
  NOT_FOUND = 4,
  NO_ENTRIES = 5,
  DB_ERROR = 6,
  DB_WRITE_ERROR = 7,
  IP_BLACKLISTED = 8,
  MESSAGE_PENDING = 9,
  NO_ROOM = 10,
  DUPLICATE_ENTRY = 11,
  PASSWORD_INVALID = 12,
  USER_ID_INVALID = 13,
  CELL_INVALID = 14,
  EMAIL_INVALID = 15,
  VERIFICATION_CODE_INVALID = 16,
  VERIFICATION_LIMIT = 17,
  TIMEOUT = 18,
  SERVER_ERROR = 19,
  MISSING_ASSOCIATION = 20,
  BAD_STATE = 21,
}
